<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='1、可设置会员规则、会员等级、会员特权以及各等级成长值；
2、会员升级以及权益会有相应的消息模块或短信推送；短信需手动设置，设置请确保短信余额充足。' :padding='true' ></SmallSquare>
    <a-card :bordered="false">
      <div class="text-ar m-b-20"> 
        <a-button type='primary' v-has:userCardLog='()=>{showLog=true}'>操作记录</a-button>
      </div>
      <setting />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="操作记录（只记录近30天操作记录）" centered v-model:visible="showLog" :width='1300' :footer="null" destroyOnClose>
    <vipLog></vipLog>
  </a-modal>
</template>
<script>
  import setting from './components/setting'
  import vipLog from './components/operationLog'
  import { ref } from "vue";
  export default {
    components: {  setting,vipLog },
    setup() {
    return {
      showLog:ref(false)
    };
  },
  }
</script>